<template>
  <div v-if="isIntegrationEnabled('yotpo')" :class="{ relative: $storyblok.isEditing.value }">
    <KetchWrapper name="Social Images" class="bg-gray-lighter">
      <YotpoImageCarousel :album-id="data.galleryId" />
    </KetchWrapper>

    <!-- Shade for storyblok editor to prevent clicks -->
    <div v-if="$storyblok.isEditing.value" class="absolute inset-0 z-50"></div>
  </div>
</template>

<script setup lang="ts">
const { $storyblok } = useNuxtApp()
const { isIntegrationEnabled } = useUtils()

interface YotpoSocialImagesWidget extends Widget {
  galleryId: string
}

const { data } = defineProps<{
  data: YotpoSocialImagesWidget
}>()
</script>
